<div class="p-2">
    <adaa-data-table
        #adaaDataTable
        [apiName]="'getFAQSCategoryHelp'"
        [titleHeader]="'breadcrumbs.faqs_category.list' | translate"
        [configKey]="Constants.MAIN_TABLE_LIST_CONF_KEY.HELP_FAQS_CATEGORY"
        [enableViewAction]="false"
        (actionClicked)="getAction($event)"
        (addNewClicked)="addNew()"
    ></adaa-data-table>
</div>

<adaa-faqs-category-editor #category [pageMode]="pageMode()" (category)="submit($event)"></adaa-faqs-category-editor>
